import React from 'react';
import { Mail, Phone, MapPin, Facebook, Instagram, Linkedin } from 'lucide-react';

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-[#1e5a7a] text-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Company Info */}
          <div>
            <div className="flex items-center mb-4">
              <img 
                src="https://customer-assets.emergentagent.com/job_982f1f8b-d55b-4c68-9981-e0def6f33939/artifacts/m727ocae_IMMO%20CONCEPT-2.png" 
                alt="IMMO CONCEPT" 
                className="h-32 w-auto object-contain"
              />
            </div>
            <p className="text-white/80 leading-relaxed">
              Promoteur immobilier de prestige en Suisse Romande. Créateur d'espaces d'exception depuis 2022.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-bold mb-4 text-[#f5b800]">Liens Rapides</h3>
            <ul className="space-y-2">
              <li>
                <button
                  onClick={() => scrollToSection('realisations')}
                  className="text-white/80 hover:text-[#f5b800] transition-colors"
                >
                  Nos Réalisations
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('properties')}
                  className="text-white/80 hover:text-[#f5b800] transition-colors"
                >
                  Biens à Vendre
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('services')}
                  className="text-white/80 hover:text-[#f5b800] transition-colors"
                >
                  Services
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('contact')}
                  className="text-white/80 hover:text-[#f5b800] transition-colors"
                >
                  Contact
                </button>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-bold mb-4 text-[#f5b800]">Contact</h3>
            <ul className="space-y-3">
              <li className="flex items-start">
                <MapPin size={18} className="mr-2 mt-1 flex-shrink-0" />
                <span className="text-white/80">Route de berne 223<br />1066 Epalinges, Suisse</span>
              </li>
              <li className="flex items-center">
                <Phone size={18} className="mr-2 flex-shrink-0" />
                <a href="tel:+41795100855" className="text-white/80 hover:text-[#f5b800] transition-colors">
                  +41 (0)79 510 08 55
                </a>
              </li>
              <li className="flex items-center">
                <Mail size={18} className="mr-2 flex-shrink-0" />
                <div className="text-white/80">
                  <a href="mailto:info@immoconceptsuisse.com" className="hover:text-[#f5b800] transition-colors block">
                    info@immoconceptsuisse.com
                  </a>
                  <a href="mailto:guillaume@immoconceptsuisse.com" className="hover:text-[#f5b800] transition-colors block">
                    guillaume@immoconceptsuisse.com
                  </a>
                </div>
              </li>
            </ul>
          </div>

          {/* Social Media */}
          <div>
            <h3 className="text-lg font-bold mb-4 text-[#f5b800]">Suivez-nous</h3>
            <div className="flex space-x-4">
              <a
                href="#"
                className="w-10 h-10 bg-white/10 rounded-full flex items-center justify-center hover:bg-[#f5b800] transition-all duration-300 hover:scale-110"
                aria-label="Facebook"
              >
                <Facebook size={20} />
              </a>
              <a
                href="#"
                className="w-10 h-10 bg-white/10 rounded-full flex items-center justify-center hover:bg-[#f5b800] transition-all duration-300 hover:scale-110"
                aria-label="Instagram"
              >
                <Instagram size={20} />
              </a>
              <a
                href="https://www.linkedin.com/company/immoconcept-rieme/"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-white/10 rounded-full flex items-center justify-center hover:bg-[#f5b800] transition-all duration-300 hover:scale-110"
                aria-label="LinkedIn"
              >
                <Linkedin size={20} />
              </a>
            </div>
            <p className="mt-6 text-white/80 text-sm">
              Rejoignez notre communauté et restez informé de nos nouvelles opportunités immobilières.
            </p>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/20 mt-12 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-white/60 text-sm">
              © {currentYear} IMMO CONCEPT. Tous droits réservés.
            </p>
            <div className="flex space-x-6 mt-4 md:mt-0">
              <a href="/politique-confidentialite" className="text-white/60 hover:text-[#f5b800] text-sm transition-colors">
                Politique de Confidentialité
              </a>
              <a href="/conditions-generales" className="text-white/60 hover:text-[#f5b800] text-sm transition-colors">
                Conditions Générales
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};